import type { TAttachment } from '../../attachments';
import type { TCommissionLiabilityStatus } from '../schemas';

export const getCommissionLiabilityStatus = (
    attachment: TAttachment | null | undefined,
): TCommissionLiabilityStatus => {
    if (!attachment) return 'WAITING_FOR_INVOICE';
    return attachment.paymentDate ? 'PAID' : 'UNPAID';
};
